import { Center, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Spinner } from "@chakra-ui/react";
import React from "react";

export default class SavingModal extends React.Component<{ isOpen:boolean, text?:string|undefined}> {
    render() {
        return (<>
            <Modal isOpen={this.props.isOpen} onClose={() => { }} isCentered>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader textAlign='center'>
                            {this.props.text ?? "Saving"}
                        </ModalHeader>
                        <ModalBody>
                            <Center p={4}>
                                <Spinner />
                            </Center>
                        </ModalBody>
                    </ModalContent>
                </Modal>
        </>);
    }
}